$(function () {

    $(document).ready(function () {

        var owl1 = $('.ze-info-carousel .owl-c-1');

        if (owl1.length > 0) {
            owl1.each(function () {
                var carousel = $(this);

                carousel.owlCarousel({
                    items: 1,
                    loop: true,
                    margin: 30,
                    nav: true,
                    smartSpeed: 900,
                    autoplay: carousel.data('auto-scroll'),
                    autoplayHoverPause: true,
                    navText: ["<i class='fa fa-chevron-left'></i>", "<i class='fa fa-chevron-right'></i>"]
                });
            });
        }

        var owl2 = $('.ze-info-carousel .owl-c-2');

        if (owl2.length > 0) {
            owl2.each(function () {
                var carousel = $(this);

                carousel.owlCarousel({
                    items: 2,
                    loop: true,
                    margin: 30,
                    nav: true,
                    smartSpeed: 900,
                    autoplay: carousel.data('auto-scroll'),
                    autoplayHoverPause: true,
                    navText: ["<i class='fa fa-chevron-left'></i>", "<i class='fa fa-chevron-right'></i>"],
                    responsive: {
                        0: {
                            items: 1,
                        },
                        1024: {
                            items: 2,
                        },
                    }
                });
            });
        }
    });

});